import {
  TrustedApplicationSurveyResult,
  TrustedAppRating,
} from 'domains/trustedApps/models/ITrustedApplication'

export interface IAddTrustedAppSelection {
  applicationId: number
  technicalNotes: string
  instructionalNotes: string
  coreOrSupplemental?: string
  subjects?: string[]
  grades?: string[]
  reviwedByInstructionalDesigners?: boolean
  rosteringMethod?: string
  gradePassbackMethod?: string
  accessMethods?: string[]
  securityReview?: string
  learningStandardsAlignment?: string
  downstreamAnalytics?: string
  dataSharing?: string
  licensingCoverage: string[]
  licensingExpirationDate?: number
  licensingFees?: string
  rating?: TrustedAppRating
  tags?: string[]
  surveyResults?: TrustedApplicationSurveyResult[]
}

export const hasAdditionalInfo = (app?: IAddTrustedAppSelection): boolean => {
  const values = [
    app?.technicalNotes,
    app?.instructionalNotes,
    app?.coreOrSupplemental,
    app?.subjects,
    app?.grades,
    app?.reviwedByInstructionalDesigners,
    app?.rosteringMethod,
    app?.gradePassbackMethod,
    app?.accessMethods,
    app?.securityReview,
    app?.learningStandardsAlignment,
    app?.licensingCoverage,
    app?.licensingFees,
    app?.licensingExpirationDate,
    app?.surveyResults,
  ]
  const nonNullValues = values.filter((val) => {
    if (Array.isArray(val)) {
      return val.length > 0
    }

    return ![undefined, null, ''].includes(val as any)
  })

  return nonNullValues.length > 0
}
